<template>
  <div>
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="this.loadpage == false">
      <!-- header balance -->
      <!-- <b-card no-body>
        <b-card-header class="align-items-center">
          <div class="h5">ยอด Balance : 
            <span :class="this.balance.balanceBaht >= 0 ? 'text-success' : 'text-danger'">
              {{format_price(this.balance.balanceBaht)}} 
            </span>
            บาท
          </div>
          <b-button variant="primary" v-b-modal.topup>เติม Balance</b-button>
        </b-card-header>
      </b-card> -->

      <b-card>
        <b-row class="align-items-center">
          <b-col class="col-12 col-md-9 align-items-center">
            <div class="h5">
              <span>
                <b-img
                  :src="this.balance.balanceBaht >= 0 ? require('@/assets/status-list/baht-green.png') : require('@/assets/status-list/baht-red.png')"
                  width="48px"
                  height="48px"
                />
              </span>
              <span :class="this.balance.balanceBaht >= 0 ? 'text-success' : 'text-danger'">
                {{format_price(this.balance.balanceBaht)}} 
              </span>
              บาท
            </div>
          </b-col>
          <b-col class="col-12 col-md-3 text-right d-none d-sm-block" >
            <b-button variant="outline-primary" v-b-modal.topup>เติม Balance</b-button>
          </b-col>
          <b-col class="col-12 col-md-3 text-right d-block d-sm-none" >
            <b-button variant="outline-primary" v-b-modal.topup block>เติม Balance</b-button>
          </b-col>
        </b-row>
      </b-card>

      <!-- payment list -->
      <b-card no-body>
        <b-card-body>
          <h5>รายการรอชำระ</h5>
          <hr>
          <b-card-header class="align-items-center px-0 py-0">
            <div>
              <div v-if="this.billList.length > 0 && this.selectBill.length != 0" class="d-none d-sm-block">
                เลือกทั้งหมด {{this.billCount}} รายการ ยอด {{format_price(this.amountReviewBill)}} บาท
              </div>
              <div v-if="this.billList.length == 0">
                ไม่มีบิลที่ต้องชำระ
              </div>
            </div>
            <b-button
              :variant="this.selectBill.length > 0 ? 'danger' : 'secondary'"
              :disabled="this.selectBill.length == 0"
              @click="BillToPayment"
              class="d-none d-sm-block"
            >
              ชำระเงิน
            </b-button>
          </b-card-header>
          <!-- pc -->
          <div class="d-none d-sm-block">
            <b-table
              responsive
              :items="billList"
              :fields="billFields"
              style="width:100%"
              outlined
              borderless
              class="pt-1"
            >
              <template v-slot:head(id)>
                <b-form-checkbox
                  v-model="selectAllBill"
                  @change="selAllBill"
                />
              </template>
              <template #cell(id)="data">
                <b-form-checkbox
                  v-model="selectBill"
                  :value="data.item"
                  @change="selBill"
                />
              </template>
              <template #cell(amount)="data">
                <div>{{format_price(data.value)}}</div>
              </template>
            </b-table>
          </div>

          <!-- mobile -->
          <div class="pt-1 d-none d-block d-sm-none">
            <div v-if="this.billList.length > 0">
              <b-form-checkbox
                v-model="selectAllBill"
                class="pr-1"
                @change="selAllBill"
              >
                เลือกทั้งหมด
              </b-form-checkbox>
              <hr class="dense">
              <div v-for="(item, index) in billList" :key="index">
                <b-row class="pl-1">
                  <b-col cols="1">
                    <b-form-checkbox v-model="selectBill" :value="item" @change="selBill"/>
                  </b-col>
                  <b-col>
                    <div>{{item.description}}</div>
                  </b-col>
                </b-row>
                <hr class="dense">
              </div>
            </div>
            <b-card v-if="this.billList.length > 0 && this.selectBill.length != 0" class="sticky-bottom">
              <div class="pb-1">
                เลือกทั้งหมด {{this.billCount}} รายการ ยอด {{format_price(this.amountReviewBill)}} บาท
              </div>
              <b-button
                @click="BillToPayment"
                variant="primary"
                block
              >
                ชำระเงิน
              </b-button>
            </b-card>
          </div>
          <div v-if="this.billList.length > 0">ยอดรวม {{format_price(this.billTotal)}} บาท</div>
        </b-card-body>
      </b-card>

      <!-- topup balance -->
      <b-modal
        id="topup"
        ref="topup"
        @hidden="closeTopupBalance(1)"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
      >
        <div class="text-center ">
          <h3 class="pb-1">กรุณาระบุจำนวนที่ต้องการเติม Balance</h3>
          <cleave
            v-model="amountBalance"
            :options="options.amount"
            class="form-control "
          />
          <small v-if="this.valAmount == false" class="text-danger">กรุณาระบุจำนวนเงิน</small>
        </div>
        <div class="pt-2">
          <b-button
            class="float-right"
            variant="primary"
            @click="TopupToPayment"
          >
            ดำเนินการต่อ >>
          </b-button>
          <b-button @click="closeTopupBalance(2)" variant="outline-danger">ยกเลิก</b-button>
        </div>
      </b-modal>

      <!-- modal payment -->
      <b-modal
        ref="payment"
        id="payment"
        header-class="py-0 px-0 modal-header"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        size="sm"
      >
        <template v-slot:modal-header>
          <div>
            <b-button @click="closeModal(1)" variant="flat-light">
              <feather-icon
                icon="XIcon"
                size="20"
              />
            </b-button>
          </div>
        </template>
        <!-- step -->
        <div class="d-flex align-items-center pb-2 mt-n2">
          <div class="text-center mt-2">
            <b-avatar class="d-flex" variant="light-success" size="lg" text="1"/>
            <small>ช่องทาง<br>ชำระเงิน</small>
          </div>
          <hr style="border-top: 1px solid inset; flex-grow: 1;">
          <div class="text-center">
            <b-avatar class="d-flex" :variant="stepPay >= 1 ? 'light-success' : 'light-secondary'" size="lg" text="2"/>
              <small>ดำเนินการ</small>
          </div>
          <hr style="border-top: 1px solid inset; flex-grow: 1;">
          <div class="text-center">
            <b-avatar class="d-flex" :variant="stepPay == 2 ? 'light-success' : 'light-secondary'" size="lg" text="3"/>
            <small>สำเร็จ</small>
          </div>
        </div>

        <!-- body -->
        <div class="justify-content-md-center">
          <div v-if="stepPay == 0">
            <div>
              <h4 class="text-center">เลือกช่องทางการชำระเงิน</h4>
              <h5 class="text-center pb-1">ยอดชำระ {{format_price(this.amountReview)}} บาท</h5>
              <b-form-radio-group
                v-model="chooseMethod"
                stacked
                @change="clearVal"
              >
                <div v-for="list in paymentMethod" :key="list.length" class="pb-1 d-flex align-items-center">
                  <b-form-radio
                    v-if="balanceOrNot == false"
                    :value="list.value"
                    class="pr-1"
                    :disabled="list.value == 4 && amountReview > balance.balanceBaht"
                  >
                    {{list.text}}
                  </b-form-radio>
                  <b-form-radio
                    v-if="balanceOrNot == true && list.value != 4"
                    :value="list.value"
                    class="pr-1"
                  >
                    {{list.text}}
                  </b-form-radio>
                  <b-img
                    v-if="list.value == 1"
                    :src="require('@/assets/icon-for-payment/qr-icon.png')"
                    fluid
                    width="30px"
                    height="30px"
                  />
                  <b-img
                    v-if="list.value == 2"
                    :src="require('@/assets/icon-for-payment/visa-mastercard.png')"
                    width="70px"
                    height="70px"
                    fluid
                  />
                </div>
              </b-form-radio-group>
            </div>
            <div class="text-right">
              <b-button variant="primary" @click="nextStep(1)">ถัดไป>></b-button>
            </div>
          </div>
          <div v-if="stepPay == 1">
            <!-- qr code -->
            <div v-if="this.chooseMethod == 1">
              <div v-if="this.qrCode == null" class="text-center">
                <b-spinner
                  style="width: 5rem; height: 5rem;"
                  variant="primary"
                  label="Large Spinner"
                />
              </div>
              <div v-if="this.qrCode != null">
                <h5 class="text-center pb-1">ยอดชำระ {{format_price(this.amountReview)}} บาท</h5>
                <b-img
                  :src="`data:image/png;base64,${this.qrCode}`"
                  fluid
                  center
                  class="pb-1"
                />
                <h5 v-if="this.iterations != null" class="text-center text-danger">
                  ชำระเงินภายใน {{this.iterations}} วินาที
                </h5>
                <h5 v-if="this.iterations == null" class="text-center text-danger" @click="qrcodeAgain">
                  <b-link>
                    ขอ QRCode อีกครั้ง
                  </b-link>
                </h5>
                <div class="pb-1">
                  <h5>*เมื่อแสกนชำระเรียบร้อยระบบจะอัพเดทยอดให้อัตโนมัติ</h5>
                  <h5>
                    *หากชำระเรียบร้อยแล้วระบบไม่อัพเดทสถานะให้กรุณากดที่นี่ >> 
                    <b-button @click="checkStatusPayment" variant="primary" size="sm">เช็คสถานะการชำระเงิน</b-button>
                  </h5>
                </div>
                <b-button variant="outline-danger" @click="backStep(0)"><<กลับ</b-button>
              </div>
            </div>

            <!-- credit/debit -->
            <div v-if="this.chooseMethod == 2">
              <h4 class="text-center">สรุปยอดชำระ</h4>
              <b-row class="px-lg-2">
                <b-col class="pr-0">ยอดที่ต้องการชำระ</b-col>
                <b-col class="text-right">{{format_price(this.amountPay)}} บาท</b-col>
              </b-row>
              <b-row class="px-lg-2">
                <b-col class="pr-0">ค่าธรรมเนียม</b-col>
                <b-col class="text-right">{{format_price(this.fee)}} บาท</b-col>
              </b-row>
              <b-row class="px-lg-2">
                <b-col class="pr-0">ยอดที่ต้องชำระทั้งหมด</b-col>
                <b-col class="text-right">{{format_price(this.amountPay + this.fee)}} บาท</b-col>
              </b-row>
              <div v-if="this.urlFlashpay == true">
                <div class="text-center text-danger py-1">กรุณาทำรายการที่หน้า FlashPay</div>
                <div>
                  <div>*เมื่อชำระเรียบร้อยระบบจะอัพเดทยอดให้อัตโนมัติ</div>
                  <div>
                    *หากชำระเรียบร้อยแล้วระบบไม่อัพเดทสถานะให้กรุณากดที่นี่ >> 
                    <b-button @click="checkStatusPayment" variant="primary" size="sm">เช็คสถานะการชำระเงิน</b-button>
                  </div>
                </div>
              </div>
              <div class="pt-2">
                <b-button
                  v-if="this.urlFlashpay == false"
                  @click="reqPaymentCard()"
                  class="float-right"
                  variant="primary"
                  :disabled="this.loadBtnCard == false"
                >
                  <b-spinner v-if="this.loadBtnCard == false" small />
                  ชำระเงิน
                </b-button>
                <b-button variant="outline-danger" @click="backStep(0)"><<กลับ</b-button>
              </div>
            </div>

            <!-- bank tranfer -->
            <div v-if="this.chooseMethod == 3">
              <b-form>
                <h5 class="text-center pb-1">ยอดชำระ {{format_price(this.amountReview)}} บาท</h5>
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      class="font-weight-normal"
                      label="ธนาคาร :"
                      label-class="pt-0"
                      label-cols-md="3"
                    >
                      <b-form-radio-group v-model="chooseBank" stacked>
                        <div v-for="list in bankList" :key="list.length">
                          <b-form-radio :value="list.bankId" class="pb-1">
                              <div class="d-flex">
                                <div class="pr-1">
                                  <b-img
                                    :src="list.bankLogo"
                                    fluid
                                    width="30px"
                                    height="30px"
                                  />
                                </div>
                                <div>
                                  <div>ธนาคาร{{list.bankName}}</div>
                                  <div>{{list.accountNumber}}</div>
                                  <div>{{list.accountName}}</div>
                                </div>
                              </div>
                            <!-- {{list.fullBankName}} -->
                          </b-form-radio>
                        </div>
                      </b-form-radio-group>
                      <small v-if="this.checkBankId == false" class="text-danger">กรุณาเลือกบัญชีธนาคาร</small>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      class="font-weight-normal"
                      label="วันที่ :"
                      label-cols-md="3"
                    >
                      <flat-pickr
                        v-model="payDate"
                        class="form-control"
                        :config="datePickerConfig"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      class="font-weight-normal"
                      label="เวลา :"
                      label-cols-md="3"
                    >
                      <flat-pickr
                        v-model="payTime"
                        class="form-control"
                        :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      class="font-weight-normal"
                      label="แนบสลิป :"
                      label-cols-md="3"
                    >
                      <b-form-file
                        v-model="slipPayment"
                        placeholder="Choose a file"
                        drop-placeholder="Drop file here..."
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
              <div class="pt-2">
                <b-button
                  class="float-right"
                  variant="primary"
                  @click="payTranfersAndBalance"
                  :disabled="this.loadBtnCard == false"
                >
                  <b-spinner v-if="this.loadBtnCard == false" small />
                  ชำระเงิน
                </b-button>
                <b-button variant="outline-danger" @click="backStep(0)"><<กลับ</b-button>
              </div>
            </div>

            <!-- pay balance -->
            <div v-if="this.chooseMethod == 4">
              <h4 class="text-center">สรุปยอดชำระ</h4>
              <b-row class="px-lg-2">
                <b-col class="pr-0" cols="4">จำนวน</b-col>
                <b-col class="text-right" cols="6">{{this.billCount}}</b-col>
                <b-col class="text-right pl-0" cols="2">บิล</b-col>
              </b-row>
              <b-row class="px-lg-2">
                <b-col class="pr-0" cols="4">ยอดที่ต้องชำระ</b-col>
                <b-col class="text-right" cols="6">{{format_price(this.amountReview)}}</b-col>
                <b-col class="text-right pl-0" cols="2">บาท</b-col>
              </b-row>
              <div class="pt-2">
                <b-button
                  @click="payTranfersAndBalance"
                  class="float-right"
                  variant="primary"
                  :disabled="this.loadBtnCard == false"
                >
                  <b-spinner v-if="this.loadBtnCard == false" small />
                  ชำระเงิน
                </b-button>
                <b-button variant="outline-danger" @click="backStep(0)"><<กลับ</b-button>
              </div>
            </div>

          </div>
          <div v-if="stepPay == 2">
            <div class="text-center pb-1">
              <b-avatar
                variant="light-success"
                size="100"
              >
                <feather-icon
                  icon="CheckCircleIcon"
                  size="70"
                />
              </b-avatar>
              <h1 class="pt-1">สำเร็จ</h1>
              <h3>ยอดชำระ {{this.chooseMethod == 2 ? format_price(this.amountPay + this.fee) : format_price(this.amountReview)}} บาท</h3>
            </div>
            <div class="text-right">
              <b-button @click="closeModal(2)" variant="primary">
                ปิดหน้าต่าง ({{this.cd}})
              </b-button>
            </div>
          </div>
        </div>
      </b-modal>

      <!-- history -->
      <div v-if="this.loadpage == false" class="pb-3">
        <!-- pc -->
        <b-card no-body class="d-none d-sm-block">
          <b-card-header class="pb-0">
            <span class="d-flex">
              <feather-icon icon="AlignJustifyIcon" size="24"/>
              <h3>ประวัติการแจ้งชำระเงิน</h3>
            </span>
          </b-card-header>
          <hr class="dense"/>
          <div>
            <b-card-body class="d-flex pt-1 pb-0">
              <div class="d-flex align-items-center mb-1 ">
                <span class="px-0 col-1"> วันที่: </span>
                <flat-pickr v-model="date" class="form-control" :config="datePickerConfig"/>
                <span class="px-1"> - </span>
                <span class="px-0 col-1"> ถึงวันที่: </span>
                <flat-pickr v-model="dueDate" class="form-control mr-1" :config="datePickerConfig"/>
                <b-button variant="primary" @click="getHistory()">ค้นหา</b-button>
              </div>
            </b-card-body>
            <b-card-body>
              <b-table
                responsive
                class="position-relative"
                :items="history"
                :fields="fields"
                bordered
                table-class="table-md-responsive text-nowrap"
              >
                <template #cell(paymentID)="data">
                  <feather-icon
                    v-if="data.item.statusID == 1 || data.item.statusID == 5"
                    :id="`delete-icon-${data.value}`"
                    icon="TrashIcon"
                    class="cursor-pointer text-danger"
                    size="20"
                    @click="deletePayment(data.value)"
                  />
                  <b-tooltip
                    title="ลบ"
                    :target="`delete-icon-${data.value}`"
                    :delay="{show: '1500'}"
                  />
                </template>
                <template #cell(photoLink)="data">
                  <b-img :src="data.value" class="cursor-pointer" width="50px" @click="showImg(data.value)"></b-img>
                </template>
                <template #cell(statusText)="data">
                  <div
                    v-if="data.item.statusID == 2 || data.item.statusID == 7"
                    class="text-success"
                  >
                    {{data.value}}
                  </div>
                  <div
                    v-if="data.item.statusID == 1 || data.item.statusID == 5 || data.item.statusID == 6"
                    class="text-warning"
                  >
                    {{data.value}}
                  </div>
                </template>
              </b-table>
            </b-card-body>
          </div>
        </b-card>
        <!-- mobile -->
        <div class="d-block d-sm-none">
          <b-card class="pb-0">
            <b-card-header class="px-0 py-0">
              <span class="d-flex">
                <feather-icon icon="AlignJustifyIcon" size="24"/>
                <h3>ประวัติการแจ้งชำระเงิน</h3>
              </span>
            </b-card-header>
            <hr class="dense pb-1"/>
            <div class="d-flex align-items-center">
              <span class="px-0 col-2"> วันที่: </span>
              <flat-pickr v-model="date" class="form-control" :config="datePickerConfig"/>
            </div>
            <div class="pt-1 d-flex align-items-center">
              <span class="px-0 col-2"> ถึงวันที่: </span>
              <flat-pickr v-model="dueDate" class="form-control" :config="datePickerConfig"/>
            </div>
            <b-button class="mt-1" variant="primary" @click="getHistory()">ค้นหา</b-button>
          </b-card>
          <b-card class="py-0" v-for="item in history" :key="item.length">
            <b-card-header class="py-0 px-0">
              <div>{{item.paymentDate}}</div>
              <div>
                <feather-icon
                  v-if="item.statusID == 1 || item.statusID == 5"
                  :id="`delete-${item.paymentID}-payment`"
                  icon="Trash2Icon"
                  size="20"
                  class="cursor-pointer text-danger"
                  @click="deletePayment(item.paymentID)"
                />
                <b-tooltip
                  title="ลบ"
                  :target="`delete-${item.paymentID}-payment`"
                  :delay="{show: '1500'}"
                />
              </div>
            </b-card-header>
            <hr class="dense">
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">ช่องทาง :</b-col>
              <b-col class="pl-0">{{item.bank}}</b-col>
            </b-row>
            <h3 class="text-center pt-1">{{item.amountPaid}} ฿</h3>
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">เพื่อชำระ :</b-col>
              <b-col class="pl-0">{{item.description}}</b-col>
            </b-row>
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">หมายเหตุ :</b-col>
              <b-col class="pl-0">{{item.remark}}</b-col>
            </b-row>
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">สลิป :</b-col>
              <b-col v-if="item.photoLink" class="pl-0"><b-link @click="showImg(item.photoLink)">คลิก</b-link></b-col>
            </b-row>
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">สถานะ :</b-col>
              <b-col class="pl-0">
                <div
                  v-if="item.statusID == 2 || item.statusID == 7"
                  class="text-success"
                >
                  {{item.statusText}}
                </div>
                <div
                  v-if="item.statusID == 1 || item.statusID == 5 || item.statusID == 6"
                  class="text-warning"
                >
                  {{item.statusText}}
                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </div>
    </div>

     <b-modal ref="show-img" hide-footer centered>
      <div class="text-center">
        <b-img class="px-0" :src="this.slipImg" fluid ></b-img>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BCard, BCardHeader, BCardBody, BModal, VBToggle, BAvatar, BContainer, BLink, BTable,
  BSpinner, BImg, BFormCheckbox, BTooltip, BFormRadioGroup, BFormRadio, BFormGroup, BForm, BFormFile,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { format_price, formatDate_eng } from '@/views/global_function.js'
import axios from "axios";
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
export default {
  name: 'Taobao2youNewPayment',

  components: {
    BRow, BCol, BButton, BCard, BCardHeader, BCardBody, BModal, VBToggle, BAvatar, BContainer, BLink, BTable,
    BSpinner, BImg, BFormCheckbox, BTooltip, BFormRadioGroup, BFormRadio, BFormGroup, BForm, BFormFile,

    Cleave,
    flatPickr,
  },

  directives: {
    'b-toggle': VBToggle,
  },

  data() {
    return {
      balance: 0,
      rateExchange: 0,
      billCount: 0,
      billTotal: 0,
      amountReviewBill: 0,
      amountReview: 0,
      selectAllBill: false,
      selectBill: [],
      topupOrBill: null,
      paymentIdCallback: [],
      fee: 0,
      amountPay: 0,
      urlFlashpay: false,
      bankList: [],
      chooseBank: null,
      checkBankId: true,
      slipPayment: null,
      balanceOrNot: true,

      payDate: new Date(),
      payTime: new Date().toLocaleString(undefined, {hour: '2-digit', hour12: false, minute:'2-digit'}),
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },

      //topup
      amountBalance: '',
      options: {
        amount: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralPositiveOnly: true,
        },
      },
      valAmount: true,

      // bill
      billList: [],
      billFields: [
        { key: 'id', thStyle: { width: "2%" } },
        { key: 'description', label: 'รายละเอียด', thClass: 'text-center', class: 'left-border' },
        { key: 'amount', label: 'ยอด', thClass: 'text-center', tdClass: 'text-right', class: 'left-border' },
        { key: 'status', label: 'สถานะ', thClass: 'text-center', tdClass: 'text-center', class: 'left-border' },
      ],

      // history
      history:[],
      fields: [
        { key: 'paymentDate', label: 'ชำระเวลา', sortable: true },
        { key: 'bank', label: 'ช่องทาง' },
        { key: 'description', label:'เพื่อชำระ' },
        { key: 'amountPaid', label:'ยอด(บาท)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'photoLink', label: 'สลิป', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'remark', label:'หมายเหตุ' },
        { key: 'statusText', label:'สถานะ', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'paymentID', label:'ลบ', thClass: 'text-center', tdClass: 'text-center' },
      ],
      date: new Date(new Date().setDate(new Date().getDate()-7)).toISOString(),
      dueDate: new Date(),
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },

      //flashpay
      qrCode: null,
      // step payment
      chooseMethod: 1,
      paymentMethod: [
        { text: 'QR PAYMENT', value: 1 },
        { text: 'Credit Card/Debit Card', value: 2 },
        { text: 'โอนผ่านธนาคาร', value: 3 },
      ],
      stepPay: 0,
      // payment type
      choosePayment: 1,
      paymentList: [
        { text: 'เติมเงินเข้า Balance', value: 1 },
        { text: 'ชำระบิลต่างๆ', value: 2 },
        { text: 'แลกเงินไทย -> จีน', value: 3 },
        { text: 'ทำรายการฝากจ่าย/โอนเงินไปจีน', value: 4 },
      ],

      //นับเวลา
      iterations: null,
      interval: null,

      //นับเวลาเสร็จสิ้น
      startCd: null,
      cd: null,

      //เช็ค callback
      countCallback: null,
      setCallback: null,

      // load
      loadpage: true,
      loadBtnCard: true,

      //login data
      userData: JSON.parse(localStorage.getItem('userData')),

      slipImg: null,
    };
  },

  async created() {
    await this.toFlashPay()
    await this.getBalance()
    await this.getRate()
    this.getBankInfo()
    this.getHistory()
    await this.listPayment()

    if (JSON.parse(localStorage.getItem('auto-topup')) == true) {
      this.$refs['topup'].show()
    }
    localStorage.removeItem('auto-topup')
  },

  watch: {
    selectBill() {
      if(this.selectBill.length > 0){
        this.amountReviewBill = this.selectBill.map(i => i.amount).reduce((a, b) => a + b)
        this.billCount = this.selectBill.length
      } else {
        this.amountReviewBill = 0
        this.billCount= 0
      }
    },
    selectAllBill(){
      if(this.selectBill.length > 0){
        this.amountReviewBill = this.selectBill.map(i => i.amount).reduce((a, b) => a + b)
        this.billCount = this.selectBill.length
      } else {
        this.amountReviewBill = 0
        this.billCount= 0
      }
    },
  },

  methods: {
    format_price,
    formatDate_eng,
    toFlashPay() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const urlFP = urlParams.get('urlFlahpay')
      if (urlFP) {
        window.location.replace(urlFP, "_self")
      }
    },
    async getBalance() {
      let response = await axios.get(
        taobaoService_dotnet + 'app/Balance/get-customer-balance?LoginToken=' + this.userData.data.customerInfo.loginToken,
        { headers: header_token }
      );
      this.balance = response.data
      this.paymentMethod.push({
        'text': 'หักจาก Balance ยอดเงินที่ใช้ได้ ' + format_price(response.data.balanceBaht) + ' บาท' ,
        'value': 4
      })
    },
    async getRate() {
      let response = await axios.post(
        taobaoService_dotnet + 'api/General/get-exchange-rate',
        { headers: header_token }
      );
      this.rateExchange = response.data
    },
    async getBankInfo() {
      let response = await axios.get(
        taobaoService_dotnet + 'app/Payment/get-thai-bank-info',
        { headers: header_token }
      );
      this.bankList = response.data
    },
    async listPayment() {
      this.loadpage = true
      this.billList = []
      let response = await axios.get(
        taobaoService_dotnet + 'app/Payment/get-unpaid-bill?loginToken=' + this.userData.data.customerInfo.loginToken,
        { headers: header_token }
      );
      this.billList = await response.data.data
      this.billTotal = this.billList.map(i => i.amount).reduce((a, b) => a + b)
      this.loadpage = false
    },
    selAllBill() {
      if (this.selectAllBill == true) {
        this.selectBill = this.billList
      } else {
        this.selectBill = []
      }
    },
    selBill() {
      if ( this.selectBill.length == this.billList.length ) {
        this.selectAllBill = true
      } else {
        this.selectAllBill = false
      }
    },
    async TopupToPayment(){
      if(this.amountBalance == '' || this.amountBalance == '0'){
        this.valAmount = false
      } else {
        this.amountReview = Number(this.amountBalance.replace(/,/g, ""))
        this.topupOrBill = 1
        this.balanceOrNot = true
        this.$refs['payment'].show()
        this.valAmount = true
        this.$refs['topup'].hide()
      }
    },
    async BillToPayment(){
      this.amountReview = this.amountReviewBill
      this.topupOrBill = 2
      this.balanceOrNot = false
      this.$refs['payment'].show()
    },

    //payment qr & card
    async reqPayment() {
      //qr code
      if (this.chooseMethod == 1) {
        var listId = []
        this.selectBill.forEach((e) => {
          listId.push(e.id)
        })
        let responseReq = await axios.post(
          taobaoService_dotnet + 'app/FlashPay/flashpay-create-payment',
          // "https://localhost:5001/app/FlashPay/flashpay-create-payment",

          {
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "amount": this.amountReview,
            "description": 'เติมเงินเข้า Balance',
            "PaymentId": this.topupOrBill == 2 ? listId : [],
            "IsCard": false
          },
          { headers: header_token }
        );
        if (responseReq.data.message == 'success') {
          var keepdata = []

          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/FlashPay/flashpay-create-order-pc?paymentOrderId=' + responseReq.data.paymentId,
            headers: {
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
            'Content-Type': 'application/json'
            },
          };
          await axios(config)
          .then(function (response) { keepdata = response.data })
          .catch(function (error) { console.log(error) })

          this.paymentIdCallback = await keepdata.outTradeNo.split("_")
          this.qrCode = keepdata.qrImage;
          if (keepdata.message == "Request Succeeded") {
            this.start()
            this.checkCallback(75)
          }
        }
      }
      // credit/debit
      else if (this.chooseMethod == 2) {
        this.amountPay = this.amountReview
        this.fee = Number(this.amountReview * 0.028)
      }
    },

    async reqPaymentCard() {
      var listId = []
      await this.selectBill.forEach((e) => {
        listId.push(e.id)
      })
      this.loadBtnCard = false
      this.urlFlashpay = false
      let responseReq = await axios.post(
        taobaoService_dotnet + 'app/FlashPay/flashpay-create-payment',
        // "https://localhost:5001/app/FlashPay/flashpay-create-payment",

        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "amount": this.amountReview,
          "description": 'เติมเงินเข้า Balance',
          "PaymentId": this.topupOrBill == 2 ? listId : [],
          "IsCard": true
        },
        { headers: header_token }
      );
      if (responseReq.data.message == 'success') {
        var keepdata = []

        var config = {
          method: 'post',
          url: taobaoService_dotnet + 'app/FlashPay/flashpay-create-card?paymentOrderId=' + responseReq.data.paymentId,
          // url: 'https://localhost:5001/app/FlashPay/flashpay-create-card?paymentOrderId=' + responseReq.data.paymentId,
          headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
          },
        };
        await axios(config)
        .then(function (response) { keepdata = response.data })
        .catch(function (error) { console.log(error) })

        this.paymentIdCallback = keepdata.outTradeNo.split("_")
        if (keepdata.message == "Request Succeeded") {
          var url = window.location.href
          this.urlFlashpay = true
          window.open(url+'?urlFlahpay='+keepdata.redirectUrl)
          this.checkCallback(650)
        }
      }
      this.loadBtnCard = true
    },

    //ขอ qr code อีกครั้ง
    async qrcodeAgain() {
      var keepdata = []
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/FlashPay/flashpay-create-order-pc?paymentOrderId=' + parseInt(this.paymentIdCallback[0]),
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
      };
      await axios(config)
      .then(function (response) { keepdata = response.data })
      .catch(function (error) { console.log(error) })

      this.paymentIdCallback = keepdata.outTradeNo.split("_")
      this.qrCode = keepdata.qrImage;
      if (keepdata.message == "Request Succeeded") {
        this.start()
        this.checkCallback(75)
      }
    },

    //balnace - pay biil
    async payTranfersAndBalance() {
      if (this.chooseMethod == 3 && this.chooseBank == null) {
        this.checkBankId = false
      } else {
        this.loadBtnCard = false
        var datetime = ''
        var time12 = this.payTime.split(":")
        var listId = []
        var imgLink = null
        // format datetime
        if ( this.payDate.length == 10 ) {
          if (time12[0] == '24') {
            datetime = formatDate_eng(this.payDate) + ' ' + '00:' + time12[1]
          } else {
            datetime = formatDate_eng(this.payDate) + ' ' + this.payTime
          }
        } else  {
          if (time12[0] == '24') {
            datetime = formatDate_eng(this.payDate.toISOString().slice(0, 10)) + ' ' + '00:' + time12[1]
          } else {
            datetime = formatDate_eng(this.payDate.toISOString().slice(0, 10)) + ' ' + this.payTime
          }
        }
        //format list bill id
        if (this.selectBill.length > 0) {
          await this.selectBill.forEach((e) => {
            listId.push(e.id)
          })
        }
        // upload slip
        if (this.slipPayment != null) {
          var FormData = require('form-data');
          var data = new FormData();
          data.append('', this.slipPayment);

          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'api/General/upload-file-with-type?UploadType=8',
            headers: {
              'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
              'Content-Type': 'application/json',
            },
            data : data
          };
          await axios(config)
          .then(function (response) {
            imgLink = response.data
          })
          .catch(function (error) {
            console.log(error);
          });
        }
        // add payments
        let response = await axios.post(
          taobaoService_dotnet + 'app/Payment/new-payment',
          {
            "amount": Number(this.amountReview.toFixed(2)),
            "bankID": this.chooseMethod == 3 ? this.chooseBank : 20,
            "loginToken": this.userData.data.customerInfo.loginToken,
            "photoLink": imgLink != null ? imgLink[0] : null,
            "paymentIDList": listId != [] ? listId : [],
            "paymentDate": datetime
          },
          { headers: header_token }
        );
        if (response.data.status == "success"){
          clearInterval(this.setCallback);
          this.countCallback = null
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แจ้งชำระเงินเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.stepPay = 2
          this.startCooldown()
        }
        this.loadBtnCard = true
      }
    },

    //close
    async closeTopupBalance(id) {
      if (id == 1) {
        this.valAmount = true
        this.topupOrBill = null
        this.$refs['topup'].hide()
      } else if (id == 2) {
        this.amountBalance = ''
        this.valAmount = true
        this.topupOrBill = null
        this.$refs['topup'].hide()
      }
    },
    clearVal() {
      this.stepPay = 0
      this.qrCode = null
    },
    async closeModal(id) {
      if (id == 1) {
        this.$swal({
          title: 'ปิดหน้าต่างชำระเงิน ?',
          text: "คุณแน่ใจหรือป่าวว่าต้องการปิดหน้าต่างชำระเงิน ?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then( async result => {
          if (result.value) {
            this.topupOrBill = null
            this.stepPay = 0
            this.qrCode = null
            this.amountBalance = ''
            this.chooseMethod = 1
            this.chooseBank = null
            this.checkBankId = true
            this.slipPayment = null
            this.loadBtnCard = true
            clearInterval(this.setCallback);
            clearInterval(this.interval);
            clearInterval(this.startCd);
            this.$refs['payment'].hide()
          }
        })
      } else if (id == 2) {
        clearInterval(this.setCallback);
        clearInterval(this.interval);
        clearInterval(this.startCd);
        this.$refs['payment'].hide()
        await this.$router.push({path: '/'})
        this.$router.push({path: '/finance/payment'})
      }
    },
    async nextStep(count) {
      this.stepPay = count
      this.reqPayment()
    },
    //เช็ค callback จาก flashpay
    checkCallback(count) {
      this.countCallback = count;
      this.setCallback = setInterval(this.checkStatusCallback, 1000);
    },
    async checkStatusCallback() {
      this.countCallback--;

      var keepdata = []
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/FlashPay/callback-status?paymentId=' + parseInt(this.paymentIdCallback[0]),
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
      };
      await axios(config)
      .then(function (response) { keepdata = response.data })
      .catch(function (error) { console.log(error) })

      if (this.countCallback == 0) {
        clearInterval(this.setCallback);
      }
      if (keepdata.message == "success"){
        clearInterval(this.setCallback);
        this.countCallback = null
        if (keepdata.message == "success") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แจ้งชำระเงินเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.stepPay = 2
          this.startCooldown()
        }
      }
    },

    async checkStatusPayment() {
      var paymentId = this.paymentIdCallback[0] +'_' + this.paymentIdCallback[1]
      var keepdata = []
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/FlashPay/callback-status-flashpay?outTradeNo=' + paymentId,
        // url: 'https://localhost:5001/app/FlashPay/callback-status-flashpay?outTradeNo=' + paymentId,
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
      };
      await axios(config)
      .then(function (response) { keepdata = response.data })
      .catch(function (error) { console.log(error) })

      if (keepdata.tradeStatus == 3) {
        clearInterval(this.setCallback);
        this.countCallback = null
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'แจ้งชำระเงินเรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.stepPay = 2
        this.startCooldown()
      }
    },

    //ตัวนับเวลารอจ่ายเงิน
    start() {
      this.iterations = 60;
      this.interval = setInterval(this.foo, 1000);
    },
    foo() {
      this.iterations--;
      if (this.iterations == 0){
        clearInterval(this.interval);
        this.iterations = null
      }
    },

    //ตัวนับเวลาเสร็จสิ้น
    startCooldown() {
      this.cd = 5;
      this.startCd = setInterval(this.cooldown, 1000);
    },
    async cooldown() {
      this.cd--;
      if (this.cd == 0){
        clearInterval(this.startCd);
        this.cd = null
        await this.$router.push({path: '/'})
        this.$router.push({path: '/finance/payment'})
      }
    },

    backStep(count) {
      this.$swal({
        title: 'เลือกช่องทางชำระเงินใหม่ ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการเลือกช่องทางชำระเงินใหม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          this.stepPay = count
          this.chooseBank = null
          this.checkBankId = true
          this.slipPayment = null
          this.loadBtnCard = true
          clearInterval(this.interval);
          clearInterval(this.startCd);
        }
      })
    },

    // history table
    async getHistory(){
      let response = await axios.post(
        taobaoService_dotnet + 'app/Payment/load-payment-history-page',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "startDate": this.date,
          "endDate": this.dueDate,
          "isDescending": true
        },
        { headers: header_token }
      );
      this.history = response.data.dataList
      this.date = response.data.startDate
      this.dueDate = response.data.endDate
    },
    async deletePayment(paymentId){
      this.$swal({
        title: 'ลบการแจ้งชำระเงิน ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการลบรายการนี้ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          var axios = require('axios');
          var data = JSON.stringify({
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "paymentID": paymentId,
          });

          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/Payment/delete-payment',
            headers: {
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
            'Content-Type': 'application/json'
            },
            data : data
          };

          await axios(config)
          .then(function (response) {
          })
          .catch(function (error) {
            console.log(error);
          });
          await this.$router.push({path: '/'})
          this.$router.push({path: '/finance/payment'})
        }
      })
    },
    async showImg(img) {
      this.slipImg = await img
      this.$refs['show-img'].show()
    },
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style>
  .b-table .left-border {
    border-left: 1px solid rgb(228, 228, 228);
  }
  .item-center {
    justify-content: center;
  }
  .modal-header {
    justify-content: right;
  }
.sticky-bottom {
    position: fixed;
    bottom: -30px;
    right: 0%;
    width: 100%;
    z-index: 99;
  }
</style>